import { get } from 'lodash';
import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import { clearSelectedAnswer } from 'app/modules/self_service';
import { getSelectedSelfServiceAnswer } from 'app/modules';
import { navigateBack } from 'app/modules/ui/actions';
import overrideStyle from 'lib/overrideStyle';
import LoadingSpinner from 'presentation/components/icons/LoadingSpinner';

const Title = overrideStyle('div')`
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 18px;
`;

const Body = overrideStyle('div')`
    flex: 1 1 auto;
    overflow-y: auto;
    padding-bottom: 24px;
`;

function Loading() {
  return <LoadingSpinner />;
}

function AnswerContent(props) {
  return (
    <React.Fragment>
      <Title>{props.name}</Title>
      <Body>{props.body}</Body>
    </React.Fragment>
  );
}

export function AnswerDisplay(props) {
  return props.isLoading ? <Loading /> : <AnswerContent {...props} />;
}

AnswerDisplay.propTypes = {
  body: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onNavigateBack: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  let selectedAnswer = getSelectedSelfServiceAnswer(state);
  return {
    name: get(selectedAnswer, 'name'),
    body: get(selectedAnswer, 'bodyHtml'),
    isLoading: !selectedAnswer,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onNavigateBack: () => {
      dispatch(clearSelectedAnswer());
      dispatch(navigateBack());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnswerDisplay);
